/**
 * Model to handle site
 */
define('dataSource/site',['atn/atn', 'knockout', 'lodash'],
    function(atn, ko, _) {
        'use strict';
        /**
         * site
         * @type {ko.observableArray}
         */
        var site = ko.observable({});
        /**
         * observable object for handling errors in loading of site
         * @type {ko.observable}
         */
        var errorLoadingSite = ko.observable({});

        //the below code clears the observables passed on logout.
        atn.dataCache.addRegistry([site, errorLoadingSite]);

        return {
            site: site,
            errorLoadingSite: errorLoadingSite,
            getSite: getSite
        };
        /**
         * function to get site
         * @param  {boolean} reload        is reload required?
         * @return {jquery.promise}        promise for getting site
         */
        function getSite(reload) {
            return (reload || _.isEmpty(site())) ? fetchSite() : atn.utils.dummySuccessDeferred(site());
        }

        /**
         * fetches the site into site
         * @return {promise} promise object for fetching site
         */
        function fetchSite() {
            site({});
            return atn.rest.getObject(
                atn.config.api.site,
                'site',
                site,
                errorLoadingSite
            );
        }
    });
